import { useEffect, useState } from 'react';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ClientItemContent.css';
import { deleteClient, getClient, getClientSummaryData } from '../../utilities/api/clients';
import { useNavigate, useParams } from 'react-router-dom';
import { getServices } from '../../utilities/api/services'
// import { getClientIntakeForms, getIntakeForms } from '../../utilities/api/allForms';
import UpdateClient from '../../components/UpdateClient/UpdateClient';
import { getClientIntakeForms } from '../../utilities/api/allForms';
import FormsItem from '../../components/FormsItem/FormsItem';
import { getClientProjects } from '../../utilities/api/projectsTimeline';
import ProjectsItem from '../../components/ProjectsItem/ProjectsItem';
import UpdateProject from '../../components/UpdateProject/UpdateProject';
import { getAllUsersBasic } from '../../utilities/api/users';
import { dateSort, projNumSort } from '../../utilities/services/sortConditionally';
import PatentApplicationsList from '../../components/PatentApplicationsList/PatentApplicationsList';
import TrademarkApplicationsList from '../../components/TrademarkApplicationsList/TrademarkApplicationsList';
import { getClientPatentApplications } from '../../utilities/api/patentApplications';
import { getClientTrademarkApplications } from '../../utilities/api/trademarkApplications';
import NewProject from '../../components/NewProject/NewProject';
import NewApplication from '../../components/NewApplication/NewApplication';
import NewIntakeForm from '../../components/NewIntakeForm/NewIntakeForm';
import ResetClientPassword from '../../components/ResetClientPassword/ResetClientPassword';
import ClientAccess from '../../components/ClientAccess/ClientAccess';
import ClientItemSummary from '../../components/ClientItemSummary/ClientItemSummary';

export default function ClientItemContent({user, isMobile, toggleNotifications, formsPreferences, projectPreferences, patentApplicationPreferences, trademarkApplicationPreferences }) {
    const [loading, setLoading] = useState(false)
    const [users, setUsers] = useState([])
    const [patentSortOrder, setPatentSortOrder] = useState('desc')
    const [patentSortHeader, setPatentSortHeader] = useState('createdAt')
    const [trademarkSortOrder, setTrademarkSortOrder] = useState('desc')
    const [trademarkSortHeader, setTrademarkSortHeader] = useState('createdAt')
    const [summaryData, setSummaryData] = useState(null)
    const [forms, setForms] = useState([])
    const [projects, setProjects] = useState([])
    const [patentApplications, setPatentApplications] = useState([])
    const [trademarkApplications, setTrademarkApplications] = useState([])
    const [client, setClient] = useState(null)
    const [loadingIntakeForms, setLoadingIntakeForms] = useState(true)
    const [loadingProjects, setLoadingProjects] = useState(true)
    const [loadingPatents, setLoadingPatents] = useState(true)
    const [loadingTrademarks, setLoadingTrademarks] = useState(true)
    const [projectSortOrder, setProjectSortOrder] = useState('desc')
    const [projectSortHeader, setProjectSortHeader] = useState('createdAt')
    const [sortFormOrder, setSortFormOrder] = useState('desc')
    const [sortFormHeader, setSortFormHeader] = useState('createdAt')
    const [services, setServices] = useState(null) // Array of services objects after filteration
    const [fullClientServices, setFullClientServices] = useState(null)// Full service objects for client
    const navigate = useNavigate()
    const params = useParams()

    const getForms = async () => {
        setLoadingIntakeForms(true)
        try {
            const allForms = await getClientIntakeForms(params.clientID)
            setForms(allForms.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1))
        } catch (error) {
          console.log(error)
        }
        setLoadingIntakeForms(false)
    }

    const getPatents = async () => {
        setLoadingPatents(true)
        try {
            if (!client) return
            const clientPatentApplications = await getClientPatentApplications(user, client.clientID)
            setPatentApplications(clientPatentApplications.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1))
        } catch (error) {
            console.log(error)
        }
        setLoadingPatents(false)
    }

    const getTrademarks = async () => {
        setLoadingTrademarks(true)
        try {
            if (!client) return
            const clientTrademarkApplications = await getClientTrademarkApplications(user, client.clientID)
            setTrademarkApplications(clientTrademarkApplications.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1))
        } catch (error) {
            console.log(error)
        }
        setLoadingTrademarks(false)
    }

    const handleBackButton = () => {
        navigate(-1)
    }

    const handleProjectTableHeaderClick = (evt) => {
        const header = evt.target.id;
        const newSortOrder = projectSortOrder === 'asc' ? 'desc' : 'asc'
        setProjectSortHeader(header);
        setProjectSortOrder(newSortOrder);

        let sortedProjects = [...projects]
        if (header === 'projNum') {
            sortedProjects = projNumSort(newSortOrder, header, sortedProjects);
        } else if (['submissionDate', 'dueDate', 'clientDeadline'].includes(header)) {
            sortedProjects = dateSort(newSortOrder, header, sortedProjects);
        } else {
            sortedProjects.sort((a, b) => {
                if (newSortOrder === 'asc') {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
                } else {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
                }
            });
        }
        setProjects(sortedProjects)
    }

    const getUsers = async () => {
        try {
          const data = await getAllUsersBasic()
          // console.log(data)
          setUsers(data)
        } catch (error) {
          console.log(error)
        }
    }

    const updateProjects = async () => {
        try {
            const clientProjects = await getClientProjects(user, client._id)
            clientProjects.sort((a, b) => {
                if (projectSortOrder === 'asc') {
                    return ((typeof(a[projectSortHeader])==='string' ? a[projectSortHeader].toLowerCase() : a[projectSortHeader]) > (typeof(b[projectSortHeader])==='string' ? b[projectSortHeader].toLowerCase() : b[projectSortHeader])) ? 1 : -1
                } else {
                    return ((typeof(a[projectSortHeader])==='string' ? a[projectSortHeader].toLowerCase() : a[projectSortHeader]) < (typeof(b[projectSortHeader])==='string' ? b[projectSortHeader].toLowerCase() : b[projectSortHeader])) ? 1 : -1
                }
            });
            setProjects(clientProjects)
        } catch (error) {
            console.log(error)
        }
    }

    const updatePatentApplications = async () => {
        try {
            const clientPatentApplications = await getClientPatentApplications(user, client.clientID)
            clientPatentApplications.sort((a, b) => {
                if (patentSortOrder === 'asc') {
                    return ((typeof(a[patentSortHeader])==='string' ? a[patentSortHeader].toLowerCase() : a[patentSortHeader]) > (typeof(b[patentSortHeader])==='string' ? b[patentSortHeader].toLowerCase() : b[patentSortHeader])) ? 1 : -1
                } else {
                    return ((typeof(a[patentSortHeader])==='string' ? a[patentSortHeader].toLowerCase() : a[patentSortHeader]) < (typeof(b[patentSortHeader])==='string' ? b[patentSortHeader].toLowerCase() : b[patentSortHeader])) ? 1 : -1
                }
            });
            setPatentApplications(clientPatentApplications)
        } catch (error) {
            console.log(error)
        }
    }

    const updateTrademarkApplications = async () => {
        try {
            const clientTrademarkApplications = await getClientTrademarkApplications(user, client.clientID)
            clientTrademarkApplications.sort((a, b) => {
                if (trademarkSortOrder === 'asc') {
                    return ((typeof(a[trademarkSortHeader])==='string' ? a[trademarkSortHeader].toLowerCase() : a[trademarkSortHeader]) > (typeof(b[trademarkSortHeader])==='string' ? b[trademarkSortHeader].toLowerCase() : b[trademarkSortHeader])) ? 1 : -1
                } else {
                    return ((typeof(a[trademarkSortHeader])==='string' ? a[trademarkSortHeader].toLowerCase() : a[trademarkSortHeader]) < (typeof(b[trademarkSortHeader])==='string' ? b[trademarkSortHeader].toLowerCase() : b[trademarkSortHeader])) ? 1 : -1
                }
            });
        setTrademarkApplications(clientTrademarkApplications)
        } catch (error) {
            console.log(error)
        }
    }

    const getProjectsTimeline = async (clientID) => {
        setLoadingProjects(true)
        try {
          const clientProjects = await getClientProjects(user, clientID)
          setProjects(clientProjects.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1))
          await getUsers()
        } catch (err) {
          console.log(err)
        }
        setLoadingProjects(false)
    }

    const updateClientPage = (clientInfo) => {
        setClient(clientInfo)
    }

    const getFullClientServices = (clientInfo, serviceListInfo) => {
        clientInfo = clientInfo || client
        const serviceList = serviceListInfo || services
        if (!clientInfo) return
        const clientServices = []
        serviceList.forEach(service => {
            if (clientInfo.clientServices.includes(service.code)) {
                clientServices.push(service)
            }
        })
        setFullClientServices(clientServices)
    }

    const handleFormTableHeaderClick = (evt) => {
        const header = evt.target.id;
        const newSortOrder = sortFormOrder === 'asc' ? 'desc' : 'asc'
        setSortFormHeader(header);
        setSortFormOrder(newSortOrder);

        let sortedForms = [...forms]
        if (header === 'projectNumber') {
            sortedForms = projNumSort(newSortOrder, header, sortedForms);
        } else if (['submissionDate', 'approvalDate'].includes(header)) {
            sortedForms = dateSort(newSortOrder, header, sortedForms);
        } else {
            sortedForms.sort((a, b) => {
                if (newSortOrder === 'asc') {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
                } else {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
                }
            });
        }
        setForms(sortedForms)
    }

    const convertToString = (array) => {
        // convert array to string separated by commas and spaces
        let string = ''
        array.forEach((item, idx) => {
            if (idx === array.length - 1) {
                string += item
            } else {
                string += item + ', '
            }
        })
        return string
    }

    const deleteCurrentClient = async () => {
        try {
            await deleteClient(user._id, client._id)
            await toggleNotifications('success', 'Client deleted successfully!', '#E21D12')
            navigate('/clients')
        } catch (error) {
            console.log(error)
        }
    }

    const getClientItem = async (clientID) => {
        setLoading(true)
        try {
            const clientData = await getClient(clientID)
            setClient(clientData)
        } catch (error) {
            console.log(error)
        }
        setLoading(false)
    }

    const getAllServices = async () => {
        try {
            const services = await getServices()
            services.sort((a, b) => a.name > b.name ? 1 : -1)
            // // remove CTAF, CTS, USTS, and USTAF from services since they have been replaced by TS and TAF
            // const filteredServices = services.filter(service => !['CTAF', 'CTS', 'USTS', 'USTAF'].includes(service.code))
            // setServices(filteredServices)
            getFullClientServices(client, services)
            setServices(services)
        } catch (error) {
            console.log(error)
        }
    }

    const getSummaryContent = async (client) => {
        try {
            const data = await getClientSummaryData(client._id);
            setSummaryData(data)
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllServices()
        // eslint-disable-next-line
    }, [client])

    useEffect(() => {
        getClientItem(params.clientID)
        // eslint-disable-next-line
    }, [params.clientID])

    useEffect(() => {
        if (client && services) {
            getForms()
            getPatents()
            getTrademarks()
            getProjectsTimeline(client._id)
        }
        // eslint-disable-next-line
    }, [client, services])

    if (!['admin', 'manager'].includes(user.userType)) {
        return (
            <div className='ClientItemContent unauthorized'>
                <strong className='text-center'>You are not authorized to view this page!</strong>
            </div>
        )
    }

    if (loading) {
        return (
            <div className='ClientItemContent loading'>
                <div className="spinner-border" role="status"></div>
            </div>
        )
    }

    if (!client) {
        return (
            <div className='ClientItemContent noClient'>
                <strong>No Client Found</strong>
            </div>
        )
    }

    return (
    <div className='ClientItemContent'>
        <button className='backButton' onClick={handleBackButton}>
            <svg width="8" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 13L1 7L7 1" stroke="#1A5E9B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>&nbsp;&nbsp;Back</span>
        </button>
        <div className='topContainer'>
            <div className='topContainerContent'>
                <div className='head'>
                    <img src={require('./ClientHead.png')} alt="" />
                    <div className='floatingContent'>
                        <div className='representatives'>Representative(s): {capitalizeFirstLetter(convertToString(client.companyRepresentative))}</div>
                        <div className='deleteClient'>
                            <button className='deleteClientButton' data-bs-toggle="modal" data-bs-target={`#deleteClient`} title='delete'>
                                <svg width="15" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.7366 9.3514C17.7366 9.0984 17.5312 8.89307 17.2782 8.89307H5.18195C4.92803 8.89307 4.72362 9.0984 4.72362 9.3514C4.72362 10.2653 4.70712 11.1169 4.69153 11.9061C4.6237 15.3427 4.57878 17.6133 5.96753 19.0296C6.95387 20.0351 8.57362 20.4843 11.22 20.4843C13.8692 20.4843 15.4917 20.0342 16.4807 19.0268C17.8759 17.6041 17.8319 15.3226 17.7668 11.8667C17.7522 11.0885 17.7366 10.2497 17.7366 9.3514Z" fill="#FF6041"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M18.6312 5.84696H14.8353C14.7977 5.24746 14.6318 4.4023 14.0351 3.71663C13.4044 2.99155 12.4602 2.62305 11.2282 2.62305C9.99716 2.62305 9.05304 2.99155 8.42237 3.71663C7.82562 4.4023 7.65878 5.24746 7.6212 5.84696H3.82712C3.44762 5.84696 3.13962 6.15496 3.13962 6.53446C3.13962 6.91396 3.44762 7.22196 3.82712 7.22196H18.6312C19.0107 7.22196 19.3187 6.91396 19.3187 6.53446C19.3187 6.15496 19.0107 5.84696 18.6312 5.84696Z" fill="#FF6041"/>
                                </svg>
                            </button>
                            <div className="modal fade" id='deleteClient' data-bs-keyboard="false" aria-labelledby={`deleteClientHeader`}>
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            <svg width="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="4" y="4" width="48" height="48" rx="24" fill="#FEE4E2"/>
                                                <rect x="4" y="4" width="48" height="48" rx="24" stroke="#FEF3F2" strokeWidth="8"/>
                                                <path d="M28 24V28M28 32H28.01M38 28C38 33.5228 33.5228 38 28 38C22.4772 38 18 33.5228 18 28C18 22.4772 22.4772 18 28 18C33.5228 18 38 22.4772 38 28Z" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            <div className="modalBodyContent" id={`deleteClientHeader`}>
                                                <div>
                                                    Delete<span className='modalCompanyName'> {capitalizeFirstLetter(client.companyName)}</span>
                                                </div>
                                                <div className='deleteConfirmation tertiaryText'>
                                                    Are you sure you want to delete this client?
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="cancel" data-bs-dismiss="modal">Cancel</button>
                                            <button onClick={deleteCurrentClient} type="button" className="confirm" data-bs-dismiss="modal">Delete</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='floatingAvatar'>
                    <span>
                        {client.companyName.charAt(0).toUpperCase()}
                    </span>
                </div>
                <div className='mainContent'>
                    <div className='mainContent1'>
                        <div className='section1'>
                            <div className='clientName'>{capitalizeFirstLetter(client.companyName)}</div>
                            <button type='button' className='summary' data-bs-toggle="modal" data-bs-target={`#clientItemSummaryModal`} onClick={() => getSummaryContent(client)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-bookmark-check-fill" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5m8.854-9.646a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                                </svg>
                                Summary
                            </button>
                        </div>
                        <div className='section2'>
                            <div className='clientInfo1'>
                                <div className='clientEmail'>
                                    <svg width="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.3333 5.00016C18.3333 4.0835 17.5833 3.3335 16.6666 3.3335H3.33329C2.41663 3.3335 1.66663 4.0835 1.66663 5.00016M18.3333 5.00016V15.0002C18.3333 15.9168 17.5833 16.6668 16.6666 16.6668H3.33329C2.41663 16.6668 1.66663 15.9168 1.66663 15.0002V5.00016M18.3333 5.00016L9.99996 10.8335L1.66663 5.00016" stroke="#667085" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <span>&nbsp;{client.companyEmail}</span>
                                </div>
                                <span>&nbsp;</span>
                                <div className='clientID'>Client ID:<span>&nbsp;{client.clientID}</span></div>
                                <div className={`${client.folderLocation ? 'hasFolderLocation' : 'noFolderLocation'}`} title={client.folderLocation ? 'Folder Location' : 'No folder location provided'}>
                                    <a className='folderLocation' href={client?.folderLocation ? client.folderLocation : '#'} target='_blank' rel='noreferrer' disabled>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="currentColor" className="bi bi-folder-fill" viewBox="0 0 16 16">
                                            <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a2 2 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3m-8.322.12q.322-.119.684-.12h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981z"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                            
                            <div className='clientUpdate'>
                                <button className='updateClient' title='Update Client' data-bs-toggle="modal" data-bs-target={`#updateClientModal`}>
                                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.9898 18.9533C20.5469 18.9533 21 19.4123 21 19.9766C21 20.5421 20.5469 21 19.9898 21H14.2797C13.7226 21 13.2695 20.5421 13.2695 19.9766C13.2695 19.4123 13.7226 18.9533 14.2797 18.9533H19.9898ZM16.0299 3.69906L17.5049 4.87078C18.1097 5.34377 18.513 5.96726 18.6509 6.62299C18.8101 7.3443 18.6403 8.0527 18.1628 8.66544L9.3764 20.0279C8.97316 20.5439 8.37891 20.8341 7.74222 20.8449L4.24039 20.8879C4.04939 20.8879 3.89021 20.7589 3.84777 20.5761L3.0519 17.1255C2.91395 16.4912 3.0519 15.8355 3.45514 15.3303L9.68413 7.26797C9.79025 7.13898 9.98126 7.11855 10.1086 7.21422L12.7297 9.29967C12.8994 9.43942 13.1329 9.51467 13.377 9.48242C13.8969 9.41792 14.2471 8.94493 14.1941 8.43969C14.1622 8.1817 14.0349 7.96671 13.8651 7.80546C13.812 7.76246 11.3183 5.76301 11.3183 5.76301C11.1591 5.63401 11.1273 5.39752 11.2546 5.23735L12.2415 3.95706C13.1541 2.78534 14.7459 2.67784 16.0299 3.69906Z" fill="#2566A0"/>
                                    </svg>
                                    <span>&nbsp;&nbsp;Update Client</span>
                                </button>
                                <UpdateClient user={user} client={client} updateClientPage={updateClientPage} toggleNotifications={toggleNotifications} />
                            </div>
                        </div>
                        <div className='section3'>
                            <div className='section3Content'>
                                <svg width="40" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="22" cy="22" r="22" fill="#1A5E9B" fillOpacity="0.09"/>
                                    <path d="M30.3333 27.0994V29.5994C30.3343 29.8315 30.2867 30.0612 30.1937 30.2739C30.1008 30.4865 29.9644 30.6774 29.7934 30.8343C29.6224 30.9912 29.4205 31.1107 29.2006 31.185C28.9808 31.2594 28.7478 31.287 28.5167 31.2661C25.9523 30.9875 23.4892 30.1112 21.325 28.7078C19.3115 27.4283 17.6044 25.7212 16.325 23.7078C14.9166 21.5338 14.0402 19.0586 13.7667 16.4828C13.7458 16.2523 13.7732 16.0201 13.8471 15.8008C13.9209 15.5815 14.0396 15.38 14.1956 15.2091C14.3516 15.0382 14.5415 14.9017 14.7531 14.8082C14.9648 14.7147 15.1936 14.6663 15.425 14.6661H17.925C18.3294 14.6621 18.7215 14.8053 19.0281 15.069C19.3348 15.3328 19.535 15.699 19.5917 16.0994C19.6972 16.8995 19.8929 17.685 20.175 18.4411C20.2871 18.7394 20.3114 19.0635 20.2449 19.3752C20.1784 19.6868 20.024 19.9729 19.8 20.1994L18.7417 21.2578C19.9279 23.3441 21.6554 25.0715 23.7417 26.2578L24.8 25.1994C25.0266 24.9754 25.3126 24.821 25.6243 24.7545C25.9359 24.688 26.26 24.7123 26.5583 24.8244C27.3144 25.1066 28.0999 25.3022 28.9 25.4078C29.3048 25.4649 29.6745 25.6688 29.9388 25.9807C30.203 26.2926 30.3435 26.6907 30.3333 27.0994Z" stroke="#667085" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <div>
                                    <div className='section3ContentHeader'>Phone Number</div> 
                                    <div>{client.companyPhoneNumber}</div>
                                </div>
                            </div>
                            <div className='section3Content'>
                                <svg width="40" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="22" cy="22" r="22" fill="#1A5E9B" fillOpacity="0.09"/>
                                    <path d="M29.5 20.334C29.5 26.1673 22 31.1673 22 31.1673C22 31.1673 14.5 26.1673 14.5 20.334C14.5 18.3449 15.2902 16.4372 16.6967 15.0307C18.1032 13.6242 20.0109 12.834 22 12.834C23.9891 12.834 25.8968 13.6242 27.3033 15.0307C28.7098 16.4372 29.5 18.3449 29.5 20.334Z" stroke="#667085" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M22 22.834C23.3807 22.834 24.5 21.7147 24.5 20.334C24.5 18.9533 23.3807 17.834 22 17.834C20.6193 17.834 19.5 18.9533 19.5 20.334C19.5 21.7147 20.6193 22.834 22 22.834Z" stroke="#667085" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <div>
                                    <div className='section3ContentHeader'>Address</div>
                                    <div>
                                        {client.companyAddress}
                                        <span>
                                            {client.province &&
                                                `, ${client.province}`
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mainContent2'>
                        <div className='content'>
                            <div className='title'>
                                Client Credentials
                            </div>
                            <div className='credentialActions'>
                                <button className='clientAccess' title='View and Update Client Access'  data-bs-toggle="modal" data-bs-target={`#clientAccessModal`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"></path>
                                        <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1">
                                        </path>
                                    </svg>
                                    <span>&nbsp;Client Access</span>
                                </button>
                                <ClientAccess user={user} client={client} toggleNotifications={toggleNotifications} />
                                <button className='viewCredentials' title='View Client Credentials'  data-bs-toggle="modal" data-bs-target={`#resetClientPasswordModal`}>
                                    <svg width="16" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.875 12.375V7.875C7.875 6.38316 8.46763 4.95242 9.52252 3.89752C10.5774 2.84263 12.0082 2.25 13.5 2.25C14.9918 2.25 16.4226 2.84263 17.4775 3.89752C18.5324 4.95242 19.125 6.38316 19.125 7.875V12.375M5.625 12.375H21.375C22.6176 12.375 23.625 13.3824 23.625 14.625V22.5C23.625 23.7426 22.6176 24.75 21.375 24.75H5.625C4.38236 24.75 3.375 23.7426 3.375 22.5V14.625C3.375 13.3824 4.38236 12.375 5.625 12.375Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <span>&nbsp;Reset Password</span>
                                </button>
                                <ResetClientPassword user={user} client={client} toggleNotifications={toggleNotifications} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='bottomContainer'>
            <div className="nav nav-tabs flex-row navigation" id="v-tab" role='tablist' aria-orientation="horizontal">
                <button className="nav-link active" id='intakeFormsTab' data-bs-toggle="tab" role="tab" aria-controls="intakeFormsSection" aria-selected="true" data-bs-target="#intakeFormsSection" type="button">
                    Intake Forms
                </button>
                <button className="nav-link" id='projectsTab' data-bs-toggle="tab" role="tab" aria-controls="projectsSection" aria-selected="false" data-bs-target="#projectsSection" type="button">
                    Projects
                </button>
                <button className="nav-link" id='patentsTab' data-bs-toggle="tab" role="tab" aria-controls="patentsSection" aria-selected="false" data-bs-target="#patentsSection" type="button">
                    Patent Applications
                </button>
                <button className="nav-link" id='trademarksTab' data-bs-toggle="tab" role="tab" aria-controls="trademarksSection" aria-selected="false" data-bs-target="#trademarksSection" type="button">
                    Trademark Applications
                </button>
            </div>
            <div className='content tab-content' id="v-tabContent">
                <div className="tab-pane fade show active" id="intakeFormsSection" role="tabpanel" aria-labelledby="intakeFormsTab">
                    { loadingIntakeForms ?
                    <div className='loading'>
                        <div className="spinner-border" role="status"></div>
                    </div>
                    :
                    <>
                    <button className='creationButton' data-bs-toggle="modal" data-bs-target="#newIntakeFormModal">
                        <svg width="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="38" height="38" rx="10" fill="#FFFFFF" opacity='0.05'/>
                            <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                            <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>&nbsp;&nbsp;New Intake Form</span>
                    </button>
                    <table className='formsTable'>
                        { formsPreferences &&
                        <>
                        <thead>
                            <tr>
                                { !formsPreferences.includes('projectNumber') &&
                                <th id='projectNumber' onClick={handleFormTableHeaderClick} className='projectNumber' title='Click to sort by project number'>
                                <div className='tableHeaderWithArrow'><div>Project Number&nbsp;&nbsp;</div>
                                { sortFormHeader==='projectNumber'?
                                    <>
                                    {sortFormOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !formsPreferences.includes('title') &&
                                <th id='titleOfInvention' className='titleOfInvention'>Title</th>
                                }
                                { !formsPreferences.includes('service') &&
                                <th id='service' onClick={handleFormTableHeaderClick} className='service' title='Click to sort by service'>
                                <div className='tableHeaderWithArrow'><div>Service&nbsp;&nbsp;</div>
                                { sortFormHeader==='service'?
                                    <>
                                    {sortFormOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !formsPreferences.includes('companyName') &&
                                <th id='client' onClick={handleFormTableHeaderClick} title='Click to sort by client'>
                                <div className='tableHeaderWithArrow'><div>Client&nbsp;&nbsp;</div>
                                { sortFormHeader==='client'?
                                    <>
                                    {sortFormOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !formsPreferences.includes('createdAt') &&
                                <th id='createdAt' onClick={handleFormTableHeaderClick} className='createdAt' title='Click to sort by creation date'>
                                <div className='tableHeaderWithArrow'><div>Creation&nbsp;&nbsp;</div>
                                { sortFormHeader==='createdAt'?
                                    <>
                                    {sortFormOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !formsPreferences.includes('updatedAt') &&
                                <th id='updatedAt' onClick={handleFormTableHeaderClick} className='updatedAt' title='Click to sort by last update date'>
                                <div className='tableHeaderWithArrow'><div>Last Update&nbsp;&nbsp;</div>
                                { sortFormHeader==='updatedAt'?
                                    <>
                                    {sortFormOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !formsPreferences.includes('status') &&
                                <th id='status' onClick={handleFormTableHeaderClick} title='Click to sort by status'>
                                <div className='tableHeaderWithArrow'><div>Status&nbsp;&nbsp;</div>
                                { sortFormHeader==='status'?
                                    <>
                                    {sortFormOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !formsPreferences.includes('submissionDate') &&
                                <th id='submissionDate' onClick={handleFormTableHeaderClick} className='submissionDate' title='Click to sort by submission date'>
                                <div className='tableHeaderWithArrow'><div>Submission Date&nbsp;&nbsp;</div>
                                { sortFormHeader==='submissionDate'?
                                    <>
                                    {sortFormOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !formsPreferences.includes('approvalDate') &&
                                <th id='approvalDate' onClick={handleFormTableHeaderClick} className='approvalDate' title='Click to sort by last approval date'>
                                <div className='tableHeaderWithArrow'><div>Approval Date&nbsp;&nbsp;</div>
                                { sortFormHeader==='approvalDate'?
                                    <>
                                    {sortFormOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                <th id='actions' className='actions'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        { forms.length === 0 ?
                        <tr>
                            <td colSpan='12' className='noForms text-center'>No Forms Found</td>
                        </tr>
                        :
                        <>
                        {forms.map(form => (
                            <FormsItem user={user} key={form._id} formItem={form} isMobile={isMobile} getForms={getForms} services={services} toggleNotifications={toggleNotifications} formsPreferences={formsPreferences} />
                        ))}
                        </>
                        }
                        </tbody>
                        </>
                    }
                    </table>
                    </>
                    }
                </div>
                <div className="tab-pane fade" id="projectsSection" role="tabpanel" aria-labelledby="projectsTab">
                    { loadingProjects ?
                    <div className='loading'>
                        <div className="spinner-border" role="status"></div>
                    </div>
                    :
                    <>
                    <button className='creationButton' data-bs-toggle="modal" data-bs-target="#newProjectModal">
                        <svg width="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="38" height="38" rx="10" fill="#FFFFFF" opacity='0.05'/>
                            <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                            <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>&nbsp;&nbsp;Add Project</span>
                    </button>
                    <table className='projectsTable table'>
                        { projectPreferences &&
                        <>
                        <thead>
                            <tr>
                                { !projectPreferences.includes('projNum') &&
                                <th id='projNum' onClick={handleProjectTableHeaderClick} className='projNum' title='Click to sort by project number'>
                                    <div className='tableHeaderWithArrow'><div>Project Number&nbsp;&nbsp;</div>
                                    { projectSortHeader==='projNum'?
                                        <>
                                        {projectSortOrder==='asc' ?
                                        <div>
                                            <div className='sortIndicatorActive'>&#9650;</div>
                                            <div className='sortIndicatorInactive'>&#9660;</div>
                                        </div>
                                        : 
                                        <div>
                                            <div className='sortIndicatorInactive'>&#9650;</div>
                                            <div className='sortIndicatorActive'>&#9660;</div>
                                        </div>
                                        }
                                        </>
                                        :
                                        <div>
                                            <div className='sortIndicatorInactive'>&#9650;</div>
                                            <div className='sortIndicatorInactive'>&#9660;</div>
                                        </div>
                                    }
                                    </div>
                                </th>
                                }
                                { !projectPreferences.includes('projType') &&
                                <th id='projType' onClick={handleProjectTableHeaderClick} className='projType' title='Click to sort by service'>
                                <div className='tableHeaderWithArrow'><div>Service&nbsp;&nbsp;</div>
                                { projectSortHeader==='projType'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('projTitle') &&
                                <th id='projTitle' className='projTitle'>
                                <div className='tableHeaderWithArrow'>Title</div>
                                </th>
                                }
                                { !projectPreferences.includes('clientNumber') &&
                                <th id='clientNumber' onClick={handleProjectTableHeaderClick} title='Click to sort by client number'>
                                <div className='tableHeaderWithArrow'><div>Client Number&nbsp;&nbsp;</div>
                                { projectSortHeader==='clientNumber'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('clientName') &&
                                <th id='clientName' onClick={handleProjectTableHeaderClick} title='Click to sort by client name'>
                                <div className='tableHeaderWithArrow'><div>Client Name&nbsp;&nbsp;</div>
                                { projectSortHeader==='clientName'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('submissionDate') &&
                                <th id='submissionDate'>
                                <div className='submissionDate'>Submission Date</div>
                                </th>
                                }
                                { !projectPreferences.includes('dueDate') &&
                                <th id='dueDate' onClick={handleProjectTableHeaderClick} className='dueDate' title='Click to sort by analyst deadline'>
                                <div className='tableHeaderWithArrow dueDate'><div>Analyst Deadline&nbsp;&nbsp;</div>
                                { projectSortHeader==='dueDate'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('clientDeadline') &&
                                <th id='clientDeadline' onClick={handleProjectTableHeaderClick} className='clientDeadline' title='Click to sort by client deadline'>
                                <div className='tableHeaderWithArrow clientDeadline'><div>Client Deadline&nbsp;&nbsp;</div>
                                { projectSortHeader==='clientDeadline'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('managerName') &&
                                <th id='managerName' onClick={handleProjectTableHeaderClick} title='Click to sort by Manager Name'>
                                <div className='tableHeaderWithArrow'><div>Manager&nbsp;&nbsp;</div>
                                { projectSortHeader==='managerName'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('assignedAnalystName') &&
                                <th id='assignedAnalystName' onClick={handleProjectTableHeaderClick} title='Click to sort by analyst assigned'>
                                <div className='tableHeaderWithArrow'><div>Analyst&nbsp;&nbsp;</div>
                                { projectSortHeader==='assignedAnalystName'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('ndaStatus') &&
                                <th id='ndaStatus'>
                                <div>NDA Status</div>
                                </th>
                                }
                                { !projectPreferences.includes('contractStatus') &&
                                <th id='contractStatus'>
                                <div>Contract Status</div>
                                </th>
                                }
                                { !projectPreferences.includes('firstInvoiceStatus') &&
                                <th id='firstInvoiceStatus'>
                                <div>Invoice 1 Status</div>
                                </th>
                                }
                                { !projectPreferences.includes('intakeFormStatus') &&
                                <th id='intakeFormStatus' onClick={handleProjectTableHeaderClick} title='Click to sort by intake form status'>
                                <div className='tableHeaderWithArrow'><div>Form Status&nbsp;&nbsp;</div>
                                { projectSortHeader==='intakeFormStatus'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('projectStatus') &&
                                <th id='projectStatus' onClick={handleProjectTableHeaderClick} title='Click to sort by project status'>
                                <div className='tableHeaderWithArrow'><div>Project Status&nbsp;&nbsp;</div>
                                { projectSortHeader==='projectStatus'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('projectReportStatus') &&
                                <th id='projectReportStatus' onClick={handleProjectTableHeaderClick} title='Click to sort by report status'>
                                <div className='tableHeaderWithArrow'><div>Report Status&nbsp;&nbsp;</div>
                                { projectSortHeader==='projectReportStatus'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('secondInvoiceStatus') &&
                                <th id='secondInvoiceStatus'>
                                <div>Invoice 2 Status</div>
                                </th>
                                }
                                { !projectPreferences.includes('ndaURL') &&
                                <th id='ndaURL'>
                                <div>NDA Link</div>
                                </th>
                                }
                                { !projectPreferences.includes('contractURL') &&
                                <th id='contractURL'>
                                <div>Contract Link</div>
                                </th>
                                }
                                { !projectPreferences.includes('firstInvoiceURL') &&
                                <th id='firstInvoiceLink'>
                                <div>Invoice 1 Link</div>
                                </th>
                                }
                                { !projectPreferences.includes('formURL') &&
                                <th id='formLink'>
                                <div>Form Link</div>
                                </th>
                                }
                                { !projectPreferences.includes('projectReportURL') &&
                                <th id='projectReportLink'>
                                <div>Report Link</div>
                                </th>
                                }
                                { !projectPreferences.includes('secondInvoiceURL') &&
                                <th id='secondInvoiceLink'>
                                <div>Invoice 2 Link</div>
                                </th>
                                }
                                { !projectPreferences.includes('otherURLs') &&
                                <th id='otherLinks'>
                                <div>Other Links</div>
                                </th>
                                }
                                { !projectPreferences.includes('createdAt') &&
                                <th id='createdAt' onClick={handleProjectTableHeaderClick} title='Click to sort by creation'>
                                <div className='tableHeaderWithArrow createdAt'><div>Creation&nbsp;&nbsp;</div>
                                { projectSortHeader==='createdAt'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                { !projectPreferences.includes('updatedAt') &&
                                <th id='updatedAt' onClick={handleProjectTableHeaderClick} title='Click to sort by creation'>
                                <div className='tableHeaderWithArrow updatedAt'><div>Last Update&nbsp;&nbsp;</div>
                                { projectSortHeader==='updatedAt'?
                                    <>
                                    {projectSortOrder==='asc' ?
                                    <div>
                                        <div className='sortIndicatorActive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                    : 
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorActive'>&#9660;</div>
                                    </div>
                                    }
                                    </>
                                    :
                                    <div>
                                        <div className='sortIndicatorInactive'>&#9650;</div>
                                        <div className='sortIndicatorInactive'>&#9660;</div>
                                    </div>
                                }
                                </div>
                                </th>
                                }
                                <th id='actions' className='actions'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        { projects.length === 0 ?
                        <tr>
                            <td colSpan='12' className='noForms text-center'>No Projects Found</td>
                        </tr>
                        :
                        <>
                        {projects.map(form => (
                            <ProjectsItem user={user} key={form._id} projectItem={form} services={services} isMobile={isMobile} getProjects={getProjectsTimeline} toggleNotifications={toggleNotifications} projectPreferences={projectPreferences} />
                        ))}
                        </>
                        }
                        </tbody>
                        </>
                    }
                    </table>
                    </>
                    }
                </div>
                <div className="tab-pane fade" id="patentsSection" role="tabpanel" aria-labelledby="patentsTab">
                    { loadingPatents ?
                    <div className='loading'>
                        <div className="spinner-border" role="status"></div>
                    </div>
                    :
                    <>
                    <button className='creationButton' data-bs-toggle="modal" data-bs-target="#newApplicationModal">
                        <svg width="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="38" height="38" rx="10" fill="#FFFFFF" opacity='0.05'/>
                            <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                            <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>&nbsp;&nbsp;Add Application</span>
                    </button>
                    {/* <NewApplication user={user} toggleNotifications={toggleNotifications} updatePatentApplications={updatePatentApplications} updateTrademarkApplications={updateTrademarkApplications} /> */}
                    <PatentApplicationsList
                    user={user} 
                    patentApplicationPreferences={patentApplicationPreferences}
                    patentApplications={patentApplications} 
                    updatePatentApplications={updatePatentApplications} 
                    sortHeader={patentSortHeader} 
                    setSortHeader={setPatentSortHeader}
                    sortOrder={patentSortOrder}
                    setSortOrder={setPatentSortOrder}
                    toggleNotifications={toggleNotifications}
                    isMobile={isMobile} />
                    </>
                    }
                </div>
                <div className="tab-pane fade" id="trademarksSection" role="tabpanel" aria-labelledby="trademarksTab">
                    { loadingTrademarks ?
                    <div className='loading'>
                        <div className="spinner-border" role="status"></div>
                    </div>
                    :
                    <>
                    <button className='creationButton' data-bs-toggle="modal" data-bs-target="#newApplicationModal">
                        <svg width="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="38" height="38" rx="10" fill="#FFFFFF" opacity='0.05'/>
                            <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                            <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>&nbsp;&nbsp;Add Application</span>
                    </button>
                    <TrademarkApplicationsList
                    user={user} 
                    trademarkApplicationPreferences={trademarkApplicationPreferences}
                    trademarkApplications={trademarkApplications}
                    updateTrademarkApplications={updateTrademarkApplications} 
                    sortHeader={trademarkSortHeader}
                    setSortHeader={setTrademarkSortHeader}
                    sortOrder={trademarkSortOrder}
                    setSortOrder={setTrademarkSortOrder}
                    toggleNotifications={toggleNotifications}
                    isMobile={isMobile} />
                    </>
                    }
                </div>
                <div>
                    { projects.map((project, idx) => (
                    <UpdateProject key={idx} user={user} users={users} updateProjects={updateProjects} projectItem={project} toggleNotifications={toggleNotifications} />
                    ))}
                    { (services && fullClientServices) &&
                    <NewIntakeForm client={client} getForms={getForms} updateClientPage={updateClientPage} services={services} toggleNotifications={toggleNotifications} fullClientServices={fullClientServices} getFullClientServices={getFullClientServices} />
                    }
                    <NewProject user={user} users={users} updateProjects={updateProjects} services={services} toggleNotifications={toggleNotifications} />
                    <NewApplication user={user} toggleNotifications={toggleNotifications} updatePatentApplications={updatePatentApplications} updateTrademarkApplications={updateTrademarkApplications} />
                    <ClientItemSummary user={user} client={client} services={services} summaryData={summaryData} />
                </div>
            </div>
        </div>
    </div>
  )
}
